import AddsPromos from "../components/AddsPromos"

const AddsPromosScreen = () => {
  return (
    <AddsPromos />
  )
}
export default AddsPromosScreen